import { useState } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();

    if (honeypotValue) {
      setStatus('success');
      setMessage('感谢订阅！');
      setEmail('');
      return;
    }

    setStatus('loading');
    setMessage('');

    try {
      const payload = new URLSearchParams();
      payload.append('email', email);
      formData.forEach((value, key) => {
        if (key !== 'phone_alt') {
          payload.append(key, value as string);
        }
      });

      const response = await fetch('https://readdy.ai/api/form/d9qmc6cnlsngrm4lm20g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的加入，我们会定期为你推送最优质的耳骚内容。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后重试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '提交失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查连接后重试。');
    }
  };

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 mx-auto mb-5 flex items-center justify-center rounded-full bg-primary-100">
          <i className="ri-mail-send-line text-2xl text-primary-500"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
          订阅耳骚周刊
        </h2>
        <p className="text-sm text-foreground-600 mb-8 max-w-md mx-auto leading-relaxed">
          每周精选最优质的ASMR内容和耳机推荐，直接送到你的邮箱。让好声音，不错过。
        </p>
        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <input
            type="text"
            name="phone_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-full text-sm bg-background-50 border border-background-300 focus:border-primary-400 focus:outline-none focus:ring-2 focus:ring-primary-200 transition-all"
          />
          <button
            type="submit"
            disabled={status === 'loading'}
            className="px-8 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-all duration-300 disabled:opacity-50 whitespace-nowrap cursor-pointer"
          >
            {status === 'loading' ? '提交中...' : '立即订阅'}
          </button>
        </form>
        {message && (
          <p
            className={`mt-4 text-sm ${
              status === 'success' ? 'text-accent-600' : 'text-red-500'
            }`}
          >
            {message}
          </p>
        )}
        <p className="mt-3 text-xs text-foreground-400">
          我们尊重你的隐私，绝不发送垃圾邮件
        </p>
      </div>
    </section>
  );
}